import {combineReducers} from "redux";
import LookupReducer from './permutation_reducer';
import profileReducer from './profile_reducer';
import categoryReducer from './category_reducer';
import typeReducer from './type_reducer';
import permutationReducer from './permutation_reducer';
import brandReducer from './brand_reducer';
import lobbyReducer from './lobby_reducer';
import genreReducer from './genre_reducer';
import illustratorReducer from './illustrator_reducer';
import writerReducer from './writer_reducer';
import rarityReducer from './rarity_reducer';
import parentsReducer from './lookup_parents_reducer';
import currencyReducer from './currency_reducer';
import userLoggedInReducer from './loggedin_reducer';
import newsReducer from './news_reducer';
import cmsPagesReducer from './cms_pages_reducer';
import pagesReducer from './pages_reducer';
import fetchPagesMeta from './pages_meta_reducer';
import fetchNewsMeta from './news_meta_reducer';
import couponReducer from './coupon_reducer';
import fetchCouponMeta from './coupon_meta_reducer';
import fetchCmsPagesMeta from './cms_pages_meta_reducer';
import faqsReducer from './faqs_reducer';
import fetchFaqsMeta from './faqs_meta_reducer';
import faqTypesReducer from './faq_types_reducer';
import fetchFaqTypesMeta from './faq_types_meta_reducer'
import feedbackReducer from './feedback_reducer';
import feedbackMetaReducer from './feedback_meta_reducer';
import inventoryCategoriesReducer from './inventory_categories_reducer';
import inventoryCategoriesReducerMeta from './inventory_categories_meta_reducer';
import itemCopiesReducer from './item_copies_reducer';
import itemCopiesMetaReducer from './item_copies_meta_reducer';
import itemReducer from './item_reducer';
import itemMetaReducer from './item_meta_reducer';
import auctionReducer from './auction_reducer';
import auctionMetaReducer from './auction_meta_reducer';
import inventoryReducer from "./inventory_reducer";
import fetchInventoryMeta from "./inventory_meta_reducer";
import userReducer from "./user_reducer";
import adminUserReducer from "./admin_user_reducer";
import transactionReducer from "./transaction_reducer";
import fetchTransactionMeta from "./transaction_meta_reducer";
import fetchUsersMeta from "./user_meta_reducer";
import fetchAdminUsersMeta from "./admin_user_meta_reducer";
import lookupMainReducer from "./lookup_main_reducer";
import lookupMainMetaReducer from "./lookup_main_meta_reducer";
import collectionReducer from "./collection_item_reducer";
import collectionMetaReducer from "./collection_item_meta_reducer";
import editionReducer from "./edition_reducer"
import setReducer from "./set_reducer"
import seriesReducer from "./series_reducer"
import variationReducer from "./variation_reducer"
import ipReducer from "./ip_reducer"
import nftTypeReducer from "./nft_type_reducer"
import dlcTypeReducer from "./dlc_type_reducer"
import assetsReducer from "./assets_reducer"
import artCollectionsReducer from "./art_collection_reducer"
import artistsReducer from "./artists_reducer"
import tvKeysReducer from "./tv_key_reducer"
import fetchTvKeysReducer from "./tv_key_meta_reducer"
import redeemReducer from "./redeem_reducer"
import redeemMetaReducer from "./redeem_meta_reducer"
import parentLookupsReducer from "./parent_lookup_reducer"
import rewardsReducer from './rewards_reducer'
import badgeReducer from './badges_reducer'
import fetchRewardsMeta from './rewards_meta_reducer'
import fetchBadgesMeta from './badges_meta_reducer'
import countryReducer from "./countries_reducer";
import fetchCountriesMeta from './countries_meta_reducer';
import teamsReducer from './teams_reducer'
import teamsMetaReducer from './teams_meta_reducer'
import TradingCardsReducer from "./teams_trading_cards_reducer";
import TradingCardsMetaReducer from './teams_trading_cards_meta_reducer'
import ISLRewardsReducer from './isl_rewards_reducer';
import IslRewardsMetaReducer from './isl_rewards_meta_reducer';
import DashboardSummaryReducer from './dashboard_summary_reducer';
import DashboardStatsReducer from './dashboard_stats_reducer';
import DashboardStatsMetaReducer from './dashboard_stats_meta_reducer';

const rootReducer = combineReducers({
    lookups: LookupReducer,
    tvKeys: tvKeysReducer,
    fetchTvKeysMeta: fetchTvKeysReducer,
    profile: profileReducer,
    categories: categoryReducer,
    types: typeReducer,
    permutations: permutationReducer,
    brands: brandReducer,
    editions: editionReducer,
    sets: setReducer,
    series: seriesReducer,
    variations: variationReducer,
    rarities: rarityReducer,
    ips: ipReducer,
    nftTypes: nftTypeReducer,
    dlcTypes: dlcTypeReducer,
    assets: assetsReducer,
    artists: artistsReducer,
    artCollections: artCollectionsReducer,
    lobby: lobbyReducer,
    genre: genreReducer,
    illustrator: illustratorReducer,
    writer: writerReducer,
    parents: parentsReducer,
    currencies: currencyReducer,
    isLogin: userLoggedInReducer,
    news: newsReducer,
    fetchNewsMeta: fetchNewsMeta,
    couponMeta: fetchCouponMeta,
    coupons: couponReducer,
    cms_pages: cmsPagesReducer,
    fetchCmsPagesMeta: fetchCmsPagesMeta,
    pages: pagesReducer,
    fetchPagesMeta: fetchPagesMeta,
    faqs: faqsReducer,
    fetchFaqsMeta: fetchFaqsMeta,
    faqTypes: faqTypesReducer,
    fetchFaqTypesMeta: fetchFaqTypesMeta,
    feedbacks: feedbackReducer,
    feedbacksMeta: feedbackMetaReducer,
    inventoryCategories: inventoryCategoriesReducer,
    inventoryCategoriesMeta: inventoryCategoriesReducerMeta,
    itemCopies: itemCopiesReducer,
    itemCopiesMeta: itemCopiesMetaReducer,
    auctions: auctionReducer,
    auctionMeta: auctionMetaReducer,
    items: itemReducer,
    itemMeta: itemMetaReducer,
    inventory: inventoryReducer,
    fetchInventoryMeta: fetchInventoryMeta,
    users: userReducer,
    adminUsers: adminUserReducer,
    transactions: transactionReducer,
    transactionsMeta: fetchTransactionMeta,
    fetchUsersMeta: fetchUsersMeta,
    fetchAdminUsersMeta: fetchAdminUsersMeta,
    lookupMain: lookupMainReducer,
    parentLookups: parentLookupsReducer,
    fetchLookupMainMeta: lookupMainMetaReducer,
    collections: collectionReducer,
    rewards: rewardsReducer,
    redeems: redeemReducer,
    badges: badgeReducer,
    redeemMeta: redeemMetaReducer,
    fetchRewardsMeta: fetchRewardsMeta,
    fetchBadgesMeta: fetchBadgesMeta,
    fetchCollectionMeta: collectionMetaReducer,
    fetchCountriesMeta: fetchCountriesMeta,
    countries: countryReducer,
    teams: teamsReducer,
    teamsMeta: teamsMetaReducer,
    tradingCards: TradingCardsReducer,
    tradingCardsMeta: TradingCardsMetaReducer,
    islRewards: ISLRewardsReducer,
    islRewardsMeta: IslRewardsMetaReducer,
    summary: DashboardSummaryReducer,
    user_stats: DashboardStatsReducer,
    userStatsMeta: DashboardStatsMetaReducer,
});

export default rootReducer;
